import { useForm } from "react-hook-form"
import { Button } from "@/components/Button"
import Input from "@/components/input/Input"
import AuthLayout from "./Auth"
import { useEffect, useState } from "react"
import AuthInfo from "@/components/auth/AuthInfo"
import { useGlobalContext } from "@/global/GlobalContext"
import { getError, handleError } from "@/app/utils/helpers"
import { logOut, resetPassword } from "@/app/redux/features/auth/authSlice"
import { resetPassSchema1, resetPassSchema2 } from "@/app/utils/validation"
import { useDispatch } from "react-redux"
import { useNavigate, useSearchParams } from "react-router-dom"
import MyAccountAPI from "@/app/api/customer-dashboard/my-account"
const myAccountApi = new MyAccountAPI()

const ResetPassLayout = () => {
  const { notifyError, pathname, authStore, notifySuccess } = useGlobalContext()
  const { register, handleSubmit, reset } = useForm()
  const [onSaving, setOnSaving] = useState(false)
  const [isAuth, setIsAuth] = useState(false)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()
  const token = searchParams.get("token")
  const email = searchParams.get("email")
  const defaultErr = {
    token: "",
    email: "",
    password_current: "",
    password: "",
    password_confirm: "",
  }
  const [errors, setErrors] = useState(defaultErr)

  useEffect(() => {
    if (pathname == "/user/dashboard/change-password") setIsAuth(true)
  }, [])

  const onSubmit = async (formData) => {
    setOnSaving(true)
    const err = await resetPass(formData)
    if (err) {
      if (typeof err.error[0] == "string") {
        notifyError(err.error[0])
      } else {
        const newErrs = handleError(err)
        setErrors({ ...newErrs })
      }
    }
    setOnSaving(false)
  }

  const resetPass = async (formData) => {
    try {
      let res = {}
      if (authStore.isAuth) {
        const insertedData = resetPassSchema2.safeParse({
          password_current: formData.password_current,
          password: formData.password,
          password_confirm: formData.password_confirm
        })

        if (!insertedData.success) return { error: insertedData.error.issues }
        const { data } = await myAccountApi.changePassword(insertedData.data)
        res = data
      } else {
        const insertedData = resetPassSchema1.safeParse({
          token: token,
          email: email,
          password: formData.password,
          password_confirm: formData.password_confirm
        })

        if (!insertedData.success) return { error: insertedData.error.issues }
        res = await dispatch(resetPassword(insertedData.data)).unwrap()
      }

      // const res = await dispatch(resetPassword(insertedData.data)).unwrap()
      if (res.code == 200) {
        notifySuccess("Your password has been changed!")
        reset()
        setErrors(defaultErr)

        if (authStore.isAuth) {
          navigate("/user/dashboard/profile")
        } else {
          navigate("/auth/login")
        }
      }
    } catch (err) {
      return getError(err)
    }
  }

  return (
    <>
      <AuthLayout title="Change Password">
        <div className="mt-4 md:mt-8">
          <form onSubmit={handleSubmit(onSubmit)}>
            {isAuth && (
              <div className="mb-2.5 md:mb-5">
                <Input type="password" noLabel isInput2 placeholder="OLD PASSWORD" name="oldPassword" id="oldPassword" custCls={errors.password_current ? "border-red-600" : ""} errMsg={errors.password_current} ref={{ ...register("password_current") }} />
              </div>
            )}
            <div className="mb-2.5 md:mb-5">
              <Input type="password" noLabel isInput2 placeholder="NEW PASSWORD" name="password" id="password" custCls={errors.password ? "border-red-600" : ""} errMsg={errors.password} ref={{ ...register("password") }} />
            </div>
            <div className="mb-2.5 md:mb-5">
              <Input type="password" noLabel isInput2 placeholder="CONFIRM PASSWORD" name="password_confirm" id="passwordConfirm" custCls={errors.password_confirm ? "border-red-600" : ""} errMsg={errors.password_confirm} ref={{ ...register("password_confirm") }} />
            </div>
            <Button type="submit" isSaving={onSaving} title="Change Password" custCls="text-sm sm:text-base tracking-wide pt-2.5 pb-1.5 mt-3 font-light rounded-full" />
          </form>
          {!isAuth && (
            <AuthInfo text1="Back to " text2="Login" link="/auth/login" />
          )}
        </div>
      </AuthLayout>
    </>
  )
}

export default ResetPassLayout